import Betting from '../model/betting';

/**
 * Betting service
 * @type {{init: (function()), getBettingSvc: (function())}}
 */
export const BettingSvc = {
  /**
   * Initialize betting service
   */
  init() {
    this.bettingSvc = new Betting();
  },

  /**
   * Get betting service
   * @returns {Betting | BettingSvc}
   */
  getBettingSvc() {
    return this.bettingSvc;
  },
};






// WEBPACK FOOTER //
// betting.service.js